import script from "./PantallaUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaUsuario.vue?vue&type=script&setup=true&lang=js"

import "./PantallaUsuario.vue?vue&type=style&index=0&id=38529fe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38529fe4"]])

export default __exports__